import { Tooltip } from '@/components/Tooltip/Tooltip.js';
import { type ComponentProps } from 'react';

export const SidebarTooltip = ({
  css,
  ...props
}: ComponentProps<typeof Tooltip>) => {
  return (
    <Tooltip
      side="top"
      sideOffset={-8}
      {...props}
      asChild
      css={{ ...css, fontSize: '$14' }}
    />
  );
};
